import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import RouteDetail from "@/pages/RouteDetail";
import Alerts from "@/pages/Alerts";
import DataSources from "@/pages/DataSources";
import ManualOverride from "@/pages/ManualOverride";
import Settings from "@/pages/Settings";
import Reports from "@/pages/Reports";
import PXDashboard from "@/pages/PXDashboard";
import PXRouteDetail from "@/pages/PXRouteDetail";
import PXReports from "@/pages/PXReports";
import Layout from "@/components/app/Layout";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-navy flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-2 border-ci-orange border-t-transparent rounded-full animate-spin" />
          <p className="text-text-secondary font-manrope text-sm">Loading...</p>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="dark">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="routes/:routeId" element={<RouteDetail />} />
              <Route path="alerts" element={<Alerts />} />
              <Route path="data-sources" element={<DataSources />} />
              <Route path="overrides" element={<ManualOverride />} />
              <Route path="reports" element={<Reports />} />
              <Route path="settings" element={<Settings />} />
              <Route path="px" element={<PXDashboard />} />
              <Route path="px/routes/:routeId" element={<PXRouteDetail />} />
              <Route path="px/alerts" element={<Alerts programme="PX" />} />
              <Route path="px/reports" element={<PXReports />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
